'use client';
import * as React from 'react';
import { BreadcrumbList } from './breadcrumb-list.component.js';
import { BreadcrumbsContainer } from './breadcrumbs-container.component.js';
import { createComponent } from '../core/create-component.js';

const Breadcrumbs = createComponent({
    root: BreadcrumbsContainer,
    displayName: 'Breadcrumbs',
    propConfig: {
        wrapChildren (props) {
            return /*#__PURE__*/ React.createElement(BreadcrumbList, null, props.children);
        }
    }
});

export { Breadcrumbs };
